import fontClasses from './fonts.module.css';
import weightClasses from './weights.module.css';

export const weightMap = {
  '100': weightClasses.thin,
  '200': weightClasses.extraLight,
  '300': weightClasses.light,
  '400': weightClasses.regular,
  '500': weightClasses.medium,
  '600': weightClasses.semiBold,
  '700': weightClasses.bold,
  '800': weightClasses.extraBold,
  '900': weightClasses.black,
};

export type TypographyWeight = keyof typeof weightMap;

export const variantsMap = {
  // headings
  h1: fontClasses.h1,
  h2: fontClasses.h2,
  h3: fontClasses.h3,
  h4: fontClasses.h4,
  h5: fontClasses.h5,
  h6: fontClasses.h6,
  h7: fontClasses.h7,

  'subheader-xl': fontClasses.subheaderXl,
  'subheader-l': fontClasses.subheaderL,
  'subheader-m': fontClasses.subheaderM,
  'body-xl': fontClasses['subheader-xl'],
  'body-6': fontClasses.body6,
  'body-5': fontClasses.body5,
  'body-4': fontClasses.body4,
  'body-3': fontClasses.body3,
  'body-2': fontClasses.body2,
  'body-1': fontClasses.body1,
  'body-short': fontClasses.bodyShort,
  'caption-2': fontClasses.caption2,
  'caption-1': fontClasses.caption1,
  'code-3': fontClasses.code3,
  'code-3-inline': fontClasses['code-3-inline'],
  'code-2': fontClasses.code2,
  'code-2-inline': fontClasses['code-2-inline'],
  'code-1': fontClasses.code1,
  'code-1-inline': fontClasses['code-1-inline'],
};

export type TypographyVariant = keyof typeof variantsMap;

type TextElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span' | 'p';
export const elementMaps: Record<TypographyVariant, TextElement> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  h7: 'span',
  'subheader-xl': 'h1',
  'subheader-l': 'span',
  'subheader-m': 'span',
  'body-xl': 'span',
  'body-6': 'span',
  'body-5': 'span',
  'body-4': 'span',
  'body-3': 'span',
  'body-2': 'span',
  'body-1': 'span',
  'body-short': 'span',
  'caption-2': 'span',
  'caption-1': 'span',
  'code-3': 'span',
  'code-3-inline': 'span',
  'code-2': 'span',
  'code-2-inline': 'span',
  'code-1': 'span',
  'code-1-inline': 'span',
};

export interface TypographyProps {
  variant: TypographyVariant;
  as?: string;
  weight?: TypographyWeight;
}
